var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"mb-2 text-muted font-size-14"},[_vm._v("REFERENCE: "+_vm._s(_vm.product.reference))]),_vm._v(" "),_c('h1',{staticClass:"text-capitalize mb-3"},[_vm._v(_vm._s(_vm.product.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }